/**
* Nom : targetDelete.js
* Description : Ce fichier contient la définition de la page targetDelete 
*               Cette page affiche un message de confirmation pour supprimer une cible
* Date de création : 23 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TargetDelete : affiche un message de confirmation pour supprimer une cible
*
* Type : page 
*
* Parametres : 
*  None
*/
function TargetDelete() {

    //Define useParam
    const { id } = useParams()


    // Define useState hooks
    const [oldTarget, setOldTarget] = useState(null)
    const [statusOldTarget, setStatusOldTarget] = useState(null)
    const [statusDeletedTarget, setStatusDeletedTarget] = useState(null)
    const [isDataLoading, setDataLoading] = useState(false)


    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();

    const navigate = useNavigate();


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData() {
        // Token
        const token = "Bearer " + authToken
        // Delete target 
        const response = await fetch(path + "/api/bo-taet/" + id + "/", 
          {
            method: 'DELETE',
            credentials: 'include',
            mode: 'cors',
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token,
            }
          }
        );
        setStatusDeletedTarget(response["status"])
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        sendData()
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve target details
        const resTarget = await fetch(path + "/api/bo-taet/" + id + "/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataTarget = await resTarget.json();
        setStatusOldTarget(resTarget["status"])
        setOldTarget(dataTarget)
        // Dataloading
        setDataLoading(false)
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(statusDeletedTarget === 204) {
            const target_path = '/targets/'
            navigate(target_path)
        } else {
            const target_path = '/targets/' + id + "/delete"
            navigate(target_path)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusDeletedTarget, navigate]);


    // Render component
    return (
        <div>
            <TabRD tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        oldTarget ? (
                            <div>
                                {/*Lien de retour*/}
                                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/targets/' + id}>Retour au détail de la cible</BackPage>
                                    </div>
                                </div>
                                <h1>Supprimer la cible {oldTarget["name"]} ?</h1>
                                {(statusDeletedTarget !== null && statusDeletedTarget !== 204) ? (
                                    <div>
                                        <div className='flex-column form-center'>
                                            <div className='button button-text' onClick={handleSubmit}>Valider</div>
                                        </div>
                                        <p className='form-error'>La cible ne peux pas être supprimée !</p>
                                    </div>
                                ) : (
                                    <div>
                                        <div className='flex-column form-center'>
                                            <div className='button button-text' onClick={handleSubmit}>Valider</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p>Cible non disponible {statusOldTarget} !</p>
                        )
                    )}
                </Container>
            </div>
        </div>
    );
}

export default TargetDelete;
